import React, { useState, useEffect } from 'react';

import { Input, Select, formatDisplayValue } from '../TowerEditor';

import { useDispatch } from 'react-redux';
import { changeBody, summaryWeight } from '../../../modules/tower/towerWriteSlice';
// import { UNITWEIGHT_HOISTBEAM } from './constants';

const HoistBeamForm = ({ hoistBeam, size }) => {
    const dispatch = useDispatch();

    const [newHoistBeam, setNewHoistBeam] = useState(
        hoistBeam || {},
    );

    const L = parseFloat(size?.main?.length || 0);
    const W = parseFloat(size?.main?.width || 0);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setNewHoistBeam((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    /* 수량 산출 */
    useEffect(() => {
        if (!newHoistBeam.type || newHoistBeam.type === "N/A") {
            setNewHoistBeam(prev => ({
                ...prev,
                length: '',
                unitWeight: '',
            }));
            return;
        }
        const maxLength = Math.max(L, W);
        const length = Math.ceil(maxLength * 1.25 + 2.0);

        setNewHoistBeam((prev) => ({
            ...prev,
            length,
            unitWeight: 65.5,
        }));
    }, [L, W, newHoistBeam.type]);

    /* 단위 중량 산정 */
    useEffect(() => {

    }, []);

    /* 내부 계산 */
    useEffect(() => {
        const weight = Math.ceil(newHoistBeam.length * newHoistBeam.unitWeight);

        setNewHoistBeam((prev) => ({
            ...prev,
            weight: weight || 0,
        }));
    }, [newHoistBeam.length, newHoistBeam.unitWeight]);

    /* 리덕스에 weightSum 쓰기 */
    useEffect(() => {
        dispatch(
            summaryWeight({
                key: 'hoistBeam',
                value: newHoistBeam.weight,
            })
        )
    }, [dispatch, newHoistBeam.weight]);

    /* 리덕스에 쓰기 */
    useEffect(() => {
        dispatch(
            changeBody({
                key: 'hoistBeam',
                value: newHoistBeam,
            }),
        );
    }, [dispatch, newHoistBeam]);

    return (
        <>
            <tr>
                <td>Hoist Beam</td>
                <td colSpan={3} className="input-inside-td">
                    <Select name="type" value={newHoistBeam.type} onChange={handleChange}>
                        <option value="" disabled hidden selected>
                            Select...
                        </option>
                        <option value="N/A">N/A</option>
                        <option value="Type-I">Type-I</option>
                        <option value="Type-II">Type-II</option>
                    </Select>
                </td>
                <td className="input-inside-td">
                    <Input name="length" value={newHoistBeam.length} onChange={handleChange} />
                </td>
                <td>m</td>
                <td className="right-align">{newHoistBeam.unitWeight}</td>
                <td className="right-align">{formatDisplayValue(newHoistBeam.weight)}</td>
            </tr>
            <tr>
                <td className="spacer"></td>
            </tr>
        </>
    );
};

export default HoistBeamForm;
